/** @jsxRuntime classic */
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import App from "Components/App";
import Castle from "Shared/Analytics/CastleProvider";
import { AmplitudeProvider } from "Shared/Analytics/Amplitude";
import "./index.css";

window.location.replace("https://app.dailypay.com/login");

const history = createBrowserHistory();
Sentry.init({
  environment: process.env.REACT_APP_ENV || "development", // not using NODE_ENV to differentiate between uat & production
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
    }),
  ],
  release: process.env.REACT_APP_GIT_COMMIT,
});

Castle.init();
AmplitudeProvider.init(process.env.REACT_APP_AMPLITUDE_WRITE_KEY);
ReactDOM.render(<App />, document.getElementById("root"));
